// InputNumber has already parsed locale-specific formatting. Never parse its DOM text again.
export const proformaNumericValue = event => typeof event.value === 'number' && Number.isFinite(event.value) ? event.value : null;
export const canUseProformaPercentage = project => Number.isFinite(Number(project?.net_amount)) && Number(project?.net_amount) > 0;
